var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"actions"},[_c('img',{staticClass:"avatar-md rounded-circle",attrs:{"src":_vm.photo,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }